module.exports = __webpack_public_path__ + "img/20200723_174120.b40652c4.jpg";